/**
 * Casa Platino — Collection page renderer
 * Reads inline JSON from <script id="cp-collection-data">,
 * builds filter UI, sorts and filters products in-place.
 */
(function () {
  // Size normalization: collapse messy variant labels into clean "N Pack" buckets
  var SIZE_NORMALIZE = {
    // Bath dimension-based labels
    '30 X 60 (2Pk)': '2 Pack',
    '30 X 60 (2pk)': '2 Pack',
    '30" x 60" (2 Pack)': '2 Pack',
    '36 X 72 (2Pk)': '2 Pack',
    '36 X 72 (2pk)': '2 Pack',
    '36" x 72" (2 Pack)': '2 Pack',
    '30 X 60 (4Pk)': '4 Pack',
    '30 X 60 (4pk)': '4 Pack',
    '36 X 72 (4Pk)': '4 Pack',
    '36 X 72 (4pk)': '4 Pack',
    // Kitchen dimension label
    '16 X 26': '8 Pack'
  };

  // Match common pack-size patterns and collapse them all to "N Pack".
  // Returns "N Pack" or null if no match.
  function matchPackSize(s) {
    // "N Piece", "N Pieces", "N Piece Set", "N Pack", "N Pk" — anywhere "N <pack-noun>"
    var m = s.match(/^\s*(\d+)\s*(?:Piece|Pieces|piece|pieces|Pack|pack|Pk|pk)\b/);
    if (m) return m[1] + ' Pack';
    // "Set of N" → "N Pack"
    m = s.match(/^\s*Set\s+of\s+(\d+)/i);
    if (m) return m[1] + ' Pack';
    return null;
  }

  // Return true if this raw size value should be hidden from filters entirely
  // (Shopify default placeholder for products without a real Size option).
  function isMeaninglessSize(s) {
    if (!s) return true;
    var lower = String(s).toLowerCase().trim();
    return lower === 'default title' || lower === 'default';
  }

  function normalizeSize(s) {
    if (!s) return '';
    if (SIZE_NORMALIZE[s]) return SIZE_NORMALIZE[s];
    var packed = matchPackSize(s);
    if (packed) return packed;
    // Compound size for the 18-piece Cotton Bath Towel Set
    if (s.indexOf('Bath Towel') === 0 && s.indexOf('Hand Towel') !== -1 && s.indexOf('Wash Cloth') !== -1) {
      return '18 Pack';
    }
    return s;
  }

  // Color normalization: collapse typos and dash/space variants to a single
  // canonical color name so the filter doesn't show the same color twice.
  // Keys are lowercase; values are the display name we want to keep.
  var COLOR_NORMALIZE = {
    'vanila':                 'Vanilla',
    'charcol':                'Charcoal',
    'rose down':              'Rose Dawn',
    'windowpane':             'Window Pane',
    'window pane-charcoal':   'Windowpane-Charcoal',
    'windowpane-charcoal':    'Windowpane-Charcoal',
    'polka dot-black':        'Polka Dot Black',
    'polka dot black':        'Polka Dot Black',
    'navy blue':              'Navy',
    'ticking stripe-blue':    'Ticking Stripe Blue'
  };
  function normalizeColor(c) {
    if (!c) return '';
    var key = String(c).toLowerCase().trim();
    return COLOR_NORMALIZE[key] || c;
  }

  // Sub-category rename for cleaner labels
  var SUBCAT_RENAME = {
    'Kitchen Towel': 'Kitchen Towel',
    'Kitchen Set':   'Kitchen Set',
    'Bath Sheet':    'Bath Towels',
    'Bath Towel':    'Bath Towels',
    'Hand Towel':    'Hand Towels',
    'Washcloth':     'Washcloths',
    'Towel Set':     'Towel Sets'
  };
  function displaySubCategory(productType) {
    return SUBCAT_RENAME[productType] || productType;
  }

  // State
  var ALL = [];
  var SIZE_FILTER = new Set();
  var COLOR_FILTER = new Set();
  var SUBCAT_FILTER = new Set();
  var MIN_PRICE = 0;
  var MAX_PRICE = 0;
  var PRICE_FLOOR = 0;
  var PRICE_CEILING = 0;
  var SORT = 'featured';

  function $(id) { return document.getElementById(id); }

  function init() {
    var dataNode = $('cp-collection-data');
    if (!dataNode) return;

    var data;
    try { data = JSON.parse(dataNode.textContent); }
    catch (e) { console.error('cp-collection: bad JSON', e); return; }

    ALL = data.products || [];

    if (ALL.length === 0) {
      var grid = $('cp-product-grid');
      if (grid) grid.innerHTML = '<div class="cp-empty">No products in this collection yet.</div>';
      return;
    }

    // Price floor/ceiling
    PRICE_FLOOR = Math.floor(Math.min.apply(null, ALL.map(function (p) { return p.priceMin; })));
    PRICE_CEILING = Math.ceil(Math.max.apply(null, ALL.map(function (p) { return p.priceMax; })));
    if (PRICE_FLOOR === PRICE_CEILING) PRICE_CEILING = PRICE_FLOOR + 1;
    MIN_PRICE = PRICE_FLOOR;
    MAX_PRICE = PRICE_CEILING;

    buildFilters();
    initPriceSlider();
    apply();

    $('cp-sort').addEventListener('change', function (e) {
      SORT = e.target.value;
      apply();
    });
  }

  function buildFilters() {
    var sizes = {};   // normalized size -> count of variants
    var colors = {};  // color -> count of products that have it
    var subcats = {}; // displaySubCategory -> count of products

    ALL.forEach(function (p) {
      var pSizes = new Set();
      var pColors = new Set();
      (p.variants || []).forEach(function (v) {
        if (v.size && !isMeaninglessSize(v.size)) {
          var norm = normalizeSize(v.size);
          if (norm) pSizes.add(norm);
        }
        if (v.color) pColors.add(normalizeColor(v.color));
      });
      pSizes.forEach(function (s) { sizes[s] = (sizes[s] || 0) + 1; });
      pColors.forEach(function (c) { colors[c] = (colors[c] || 0) + 1; });

      var sc = displaySubCategory(p.type);
      if (sc) subcats[sc] = (subcats[sc] || 0) + 1;
    });

    // Size filter
    var sizeList = $('cp-size-filter');
    var sizeOrder = [
      'Twin', 'Twin XL', 'Twin-Xl', 'Twin Xl', 'Full', 'Queen', 'King',
      'Calking', 'California King', 'Split King',
      '2 Pack', '4 Pack', '6 Pack', '8 Pack', '12 Pack', '18 Pack', '20 Pack', '24 Pack'
    ];
    var sortedSizes = Object.keys(sizes).sort(function (a, b) {
      var ai = sizeOrder.indexOf(a);
      var bi = sizeOrder.indexOf(b);
      if (ai === -1 && bi === -1) return a.localeCompare(b);
      if (ai === -1) return 1;
      if (bi === -1) return -1;
      return ai - bi;
    });

    if (sortedSizes.length > 1) {
      $('cp-size-filter-group').style.display = '';
      sortedSizes.forEach(function (s) {
        var id = 'cp-s-' + s.replace(/\s+/g, '-').toLowerCase();
        var li = document.createElement('li');
        li.innerHTML = '<input type="checkbox" id="' + id + '"><label for="' + id + '">' + escapeHtml(s) + '</label><span class="cp-filter-list__count">' + sizes[s] + '</span>';
        li.querySelector('input').addEventListener('change', function (e) {
          if (e.target.checked) SIZE_FILTER.add(s);
          else SIZE_FILTER.delete(s);
          apply();
        });
        sizeList.appendChild(li);
      });
    }

    // Color filter — single-select with checkmark
    var sortedColors = Object.entries(colors).sort(function (a, b) { return b[1] - a[1]; }).slice(0, 24);
    if (sortedColors.length > 1) {
      $('cp-color-filter-group').style.display = '';
      var swContainer = $('cp-color-filter');
      sortedColors.forEach(function (entry) {
        var c = entry[0];
        var count = entry[1];
        var hex = (window.CP_getColorHex && window.CP_getColorHex(c)) || '#cccccc';
        var sw = document.createElement('button');
        sw.type = 'button';
        sw.className = 'cp-swatch--filter';
        sw.style.background = hex;
        sw.title = c + ' (' + count + ')';
        sw.setAttribute('data-color', c);
        sw.setAttribute('aria-label', 'Filter by ' + c);
        sw.addEventListener('click', function () {
          var wasSelected = COLOR_FILTER.has(c);
          COLOR_FILTER.clear();
          var nodes = document.querySelectorAll('.cp-swatch--filter.is-selected');
          for (var i = 0; i < nodes.length; i++) nodes[i].classList.remove('is-selected');
          if (!wasSelected) {
            COLOR_FILTER.add(c);
            sw.classList.add('is-selected');
          }
          apply();
        });
        swContainer.appendChild(sw);
      });
    }

    // Sub-category filter (only if collection has more than 1 type)
    var sortedSubcats = Object.keys(subcats).sort();
    if (sortedSubcats.length > 1) {
      $('cp-subcat-filter-group').style.display = '';
      var subcatList = $('cp-subcat-filter');
      sortedSubcats.forEach(function (sc) {
        var id = 'cp-sc-' + sc.replace(/\s+/g, '-').toLowerCase();
        var li = document.createElement('li');
        li.innerHTML = '<input type="checkbox" id="' + id + '"><label for="' + id + '">' + escapeHtml(sc) + '</label><span class="cp-filter-list__count">' + subcats[sc] + '</span>';
        li.querySelector('input').addEventListener('change', function (e) {
          if (e.target.checked) SUBCAT_FILTER.add(sc);
          else SUBCAT_FILTER.delete(sc);
          apply();
        });
        subcatList.appendChild(li);
      });
    }
  }

  function initPriceSlider() {
    var minSlider = $('cp-price-min-slider');
    var maxSlider = $('cp-price-max-slider');
    var minLabel = $('cp-price-min-label');
    var maxLabel = $('cp-price-max-label');
    var active = $('cp-price-active');
    if (!minSlider) return;

    minSlider.min = PRICE_FLOOR; minSlider.max = PRICE_CEILING; minSlider.value = PRICE_FLOOR;
    maxSlider.min = PRICE_FLOOR; maxSlider.max = PRICE_CEILING; maxSlider.value = PRICE_CEILING;

    function update() {
      var minVal = parseInt(minSlider.value, 10);
      var maxVal = parseInt(maxSlider.value, 10);
      var span = Math.max(PRICE_CEILING - PRICE_FLOOR, 1);
      var minPct = ((minVal - PRICE_FLOOR) / span) * 100;
      var maxPct = ((maxVal - PRICE_FLOOR) / span) * 100;
      active.style.left = minPct + '%';
      active.style.right = (100 - maxPct) + '%';
      minLabel.textContent = '$' + minVal;
      maxLabel.textContent = '$' + maxVal;
    }

    function onInput(e) {
      var minVal = parseInt(minSlider.value, 10);
      var maxVal = parseInt(maxSlider.value, 10);
      if (minVal > maxVal - 1) {
        if (e.target === minSlider) minSlider.value = maxVal - 1;
        else maxSlider.value = minVal + 1;
      }
      MIN_PRICE = parseInt(minSlider.value, 10);
      MAX_PRICE = parseInt(maxSlider.value, 10);
      update();
      apply();
    }

    minSlider.addEventListener('input', onInput);
    maxSlider.addEventListener('input', onInput);
    update();
  }

  function apply() {
    var filtered = ALL.filter(function (p) {
      if (SIZE_FILTER.size > 0) {
        var hasSize = (p.variants || []).some(function (v) { return SIZE_FILTER.has(normalizeSize(v.size)); });
        if (!hasSize) return false;
      }
      if (COLOR_FILTER.size > 0) {
        var hasColor = (p.variants || []).some(function (v) { return v.color && COLOR_FILTER.has(normalizeColor(v.color)); });
        if (!hasColor) return false;
      }
      if (SUBCAT_FILTER.size > 0) {
        if (!SUBCAT_FILTER.has(displaySubCategory(p.type))) return false;
      }
      if (p.priceMax < MIN_PRICE) return false;
      if (p.priceMin > MAX_PRICE) return false;
      return true;
    });

    filtered.sort(function (a, b) {
      if (SORT === 'price-asc') return a.priceMin - b.priceMin;
      if (SORT === 'price-desc') return b.priceMin - a.priceMin;
      if (SORT === 'az') return a.title.localeCompare(b.title);
      return 0;
    });

    render(filtered);
  }

  function render(list) {
    var grid = $('cp-product-grid');
    var resultsLabel = $('cp-results-count');

    if (list.length === 0) {
      grid.innerHTML =
        '<div class="cp-empty">' +
          '<p>No products match your filters.</p>' +
          '<button type="button" class="cp-clear-filters">Clear all filters</button>' +
        '</div>';
      grid.querySelector('.cp-clear-filters').addEventListener('click', clearFilters);
      resultsLabel.textContent = 'Showing 0 of ' + ALL.length + ' products';
      return;
    }

    grid.innerHTML = list.map(function (p) {
      var colors = new Set();
      (p.variants || []).forEach(function (v) { if (v.color) colors.add(normalizeColor(v.color)); });
      var swatchHtml = Array.from(colors).slice(0, 6).map(function (c) {
        var hex = (window.CP_getColorHex && window.CP_getColorHex(c)) || '#cccccc';
        return '<span class="cp-swatch" style="background:' + hex + '" title="' + escapeAttr(c) + '"></span>';
      }).join('');

      var typeLabel = displaySubCategory(p.type);
      var fromHtml = (p.priceMin !== p.priceMax) ? '<span class="cp-card__from">From</span>' : '';
      var img = p.image || '';

      return (
        '<a href="' + escapeAttr(p.url) + '" class="cp-card">' +
          '<div class="cp-card__image-wrap">' +
            (img ? '<img class="cp-card__image" src="' + escapeAttr(img) + '" alt="' + escapeAttr(p.title) + '" loading="lazy">' : '') +
          '</div>' +
          '<div class="cp-card__info">' +
            '<div class="cp-card__type">' + escapeHtml(typeLabel) + '</div>' +
            '<div class="cp-card__name">' + escapeHtml(p.title) + '</div>' +
            '<div class="cp-card__meta">' +
              '<div class="cp-card__price-block">' +
                fromHtml +
                '<span class="cp-card__price">$' + p.priceMin.toFixed(2) + '</span>' +
              '</div>' +
              '<div class="cp-card__swatches">' + swatchHtml + '</div>' +
            '</div>' +
          '</div>' +
        '</a>'
      );
    }).join('');

    resultsLabel.textContent = 'Showing ' + list.length + ' of ' + ALL.length + ' products';
  }

  function clearFilters() {
    SIZE_FILTER.clear();
    COLOR_FILTER.clear();
    SUBCAT_FILTER.clear();
    MIN_PRICE = PRICE_FLOOR;
    MAX_PRICE = PRICE_CEILING;
    var checkboxes = document.querySelectorAll('.cp-filters input[type="checkbox"]');
    for (var i = 0; i < checkboxes.length; i++) checkboxes[i].checked = false;
    var swatches = document.querySelectorAll('.cp-swatch--filter.is-selected');
    for (var j = 0; j < swatches.length; j++) swatches[j].classList.remove('is-selected');
    var minSlider = $('cp-price-min-slider');
    var maxSlider = $('cp-price-max-slider');
    if (minSlider) {
      minSlider.value = PRICE_FLOOR;
      maxSlider.value = PRICE_CEILING;
      minSlider.dispatchEvent(new Event('input'));
    }
    apply();
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
